import { render, staticRenderFns } from "./employ.vue?vue&type=template&id=152b9970"
import script from "./employ.vue?vue&type=script&lang=js"
export * from "./employ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports